import { isMobileViewport } from '@/hooks/use-mobile';

type ToastPosition = 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right' | 'top-center' | 'bottom-center';

/**
 * A toast's own position on desktop. Phones have a single stack at the top
 * centre (see Notifications), so they ignore it; otherwise stacks in two
 * corners are drawn full width on top of each other.
 */
export const toastPosition = (desktopPosition: ToastPosition) =>
	isMobileViewport() ? undefined : desktopPosition;
